<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="thehistoryof50">
<p class="para2"><em class="italic">Motto:</em> “For Service and Courage” (<em class="italic">Za sluzhbu i khrabrost</em>)</p>
<p class="para"><em class="italic">Color of the Ribbon:</em> Orange with Black Edges</p>
<p class="centerImage"><img alt="image" id="imgfr37" src="images/imgfr37.jpg"/></p>
<p class="caption1"><em class="italic">Order of St. George 4th Class</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// therussian_thehistoryof50.vue?c684f3c8